import { render, staticRenderFns } from "./InvoiceDetails.vue?vue&type=template&id=cbce6314&scoped=true"
import script from "./InvoiceDetails.vue?vue&type=script&lang=js"
export * from "./InvoiceDetails.vue?vue&type=script&lang=js"
import style0 from "./InvoiceDetails.vue?vue&type=style&index=0&id=cbce6314&prod&lang=scss&scoped=true"
import style1 from "./InvoiceDetails.vue?vue&type=style&index=1&id=cbce6314&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbce6314",
  null
  
)

export default component.exports